module.exports = __webpack_public_path__ + "973143b0de33439ef61c747612f3f58e.woff";